import React from "react";
import { Box, Modal } from "@mui/material";

const modalStyle = {
    position: 'absolute',
    top: '40%',
    left: '50%',
    transform: 'translate(-50%, -60%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    borderRadius: '10px',
    boxShadow: 24,
    p: 4,
    paddingTop: '10px',
  };

export default function GenericModal(props) {
  
    const { body } = props
    const { sx } = props

    return <Modal
        open={props.open}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
    <Box sx={{...modalStyle, ...sx}}>
      { body }
    </Box>
  </Modal>
}